import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { clearFloat } from '~/shared/utils/styled';
import { breakpoints, getClampFullRange } from '~/theme';

export const StyledProductLine = styled.div<{ isCentered?: boolean }>(
    {
        ...clearFloat,
    },
    ifProp('isCentered', {
        display: 'flex',
        alignItems: 'center',
    })
);

export const StyledProductReceiptHeader = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spaces[1],
    marginBottom: theme.spaces[3],
    ...clearFloat,
}));

export const StyledProductImageWrapper = styled.div<{
    imageSize: { xs: number; sm: number; md: number };
}>(({ theme, imageSize }) => ({
    width: imageSize.xs,
    float: 'left',
    marginRight: getClampFullRange(theme.spacesRaw[3], theme.spacesRaw[4]),
    marginBottom: theme.spaces[3],
    flexShrink: 0,
    [breakpoints.sm]: {
        marginBottom: 0,
        width: imageSize.sm,
    },
    [breakpoints.md]: {
        marginBottom: 0,
        width: imageSize.md,
    },
}));

export const StyledProductInfo = styled.div(({ theme }) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    gap: getClampFullRange(theme.spacesRaw[3], theme.spacesRaw[4]),
}));

export const StyledSizeSelectorWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spaces[2],
    marginTop: theme.spaces[3],
    clear: 'left',
    [breakpoints.sm]: {
        clear: 'none',
    },
}));
